import { NotificationsModule } from "@/store/modules/notification.module";
import { Machine } from "xstate";
const navBarMachine = Machine({
    id: "nav-Bar",
    context: {
        skipCount: 0,
        filterType: "UnSeen",
        isNew: true,
    },
    initial: "idle",
    states: {
        idle: {
            always: [{ target: "loaded" }],
        },
        loaded: {
            on: {
                NOTIFICATION: { target: "gettingNotifications" },
            },
        },
        gettingNotifications: {
            tags: "showNotificationCard",
            invoke: {
                id: "gettingNotifications",
                src: (context, event) => NotificationsModule.GetNotifications({ skipCount: context.skipCount, filterType: context.filterType, isNew: context.isNew }),
                onDone: { target: "notificationsLoaded" },
                onError: { target: "notificationsLoaded" },
            },
        },
        notificationsLoaded: {
            on: {
                UPDATE_IS_ACTIVE: { target: "updateNotification" },
            },
        },
        updateNotification: {
            invoke: {
                id: "gettingNotifications",
                src: (context, event) => {
                    return NotificationsModule.UpdateIsActive(event.notificationId);
                },
                onDone: { target: "notificationsLoaded" },
                onError: { target: "notificationsLoaded" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {},
    guards: {},
    activities: {},
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 2000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default navBarMachine;
